import type { SweetAlertOptions, SweetAlertResult } from 'sweetalert2'
import { defineNuxtPlugin } from '#imports'
import Swal from 'sweetalert2'

export default defineNuxtPlugin(() => {
  type SweetAlertOptionsExtended = {
    onConfirm?: () => Promise<void>
  } & SweetAlertOptions

  const onConfirmHandler
    = (options: SweetAlertOptionsExtended) =>
      async (result: SweetAlertResult) => {
        if (!result.isConfirmed) {
          return result
        }

        options.onConfirm?.()

        return result
      }

  const baseOptions = (options: SweetAlertOptionsExtended) => {
    const { onConfirm: _, ...rest } = options

    return rest
  }

  return {
    provide: {
      swal: {
        danger: (options: SweetAlertOptionsExtended = {}) =>
          Swal.fire({
            icon: 'error',
            showCancelButton: true,
            ...baseOptions(options),
          }).then(onConfirmHandler(options)),
        fire: (options: SweetAlertOptionsExtended = {}) =>
          Swal.fire({
            ...baseOptions(options),
          }).then(onConfirmHandler(options)),
        success: (options: SweetAlertOptionsExtended = {}) =>
          Swal.fire({
            icon: 'success',
            showCancelButton: true,
            ...baseOptions(options),
          }).then(onConfirmHandler(options)),
        warning: (options: SweetAlertOptionsExtended = {}) =>
          Swal.fire({
            icon: 'warning',
            showCancelButton: true,
            ...baseOptions(options),
          }).then(onConfirmHandler(options)),
      },
    },
  }
})
